const { default: axios } = require("axios");
import Swal from 'sweetalert2';
import $ from 'jquery';
import moment from 'moment';
import * as _ from 'lodash'

document.querySelector('#reportsPageNonFuel') && new Vue({
    el: '#reportsPageNonFuel',
    data() {
        return {
            filters: {
                start_date: moment().format("YYYY-MM-DD"),
                end_date: moment().format("YYYY-MM-DD"),
                office_id: '',
                status: '',
            },
            isLoading: false,
            items: []
        }
    },
    mounted() {
        this.generateReport();
    },
    computed: {
        selectedOffice() {
            if (this.filters.office_id == '') {
                return null;
            }

            return offices.find(o => o.id == this.filters.office_id);
        },
    },
    methods: {
        generateReport: _.debounce(function () {
            axios.get(`${window.location.pathname}/create-nonfuel`, { params: this.filters }).then((response) => {
                this.items = response.data;
                this.isLoading = false;
                console.log(this.items)
            });
        }, 3000),
        loadReport() {
            this.items = [];
            this.isLoading = true;
            this.generateReport();
        },
        exportReport() {
            let params = new URLSearchParams(this.filters).toString();
            console.log(window.location)
            window.location.href = `${window.location.pathname.replace("reports", "report")}/export?${params}`;
        }
    },
    filters: {
        parseDate(value, format = "LLL") {
            return value ? moment(value).format(format) : '-';
        }
    }
});